import { useBunja } from 'bunja/react';
import { useAtomValue, useSetAtom } from 'jotai';

import { ProductTypeBadge } from '@flipster/features/src/misc/badge';
import { OrderAttributionMapper, orderAttributionAtom } from '@flipster/features/src/shared/order-attribution';
import { useResponsiveOverlay } from '@flipster/features/src/shared/responsive-overlay';
import { Link } from '@flipster/i18n/routing';
import { center } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { MarketEvent } from '@flipster/utils/segment/events/market';

import { marketListBunja, trackMarketListBunja } from './state';

interface Props {
  symbol: string;
  index: number;
}

export const RecentSearchHistoryItem = ({ symbol, index }: Props) => {
  const { instrumentAtomFamily } = useBunja(marketListBunja);
  const instrument = useAtomValue(instrumentAtomFamily(symbol));
  const setOrderAttribution = useSetAtom(orderAttributionAtom);
  const { clickSymbol } = useBunja(trackMarketListBunja);
  const { setOpen } = useResponsiveOverlay();

  const handleClick = () => {
    setOrderAttribution(OrderAttributionMapper.trade.recentHistory);
    segment.track(MarketEvent.SearchHistoryClick, { trade_type: instrument.productType, symbol });
    clickSymbol('Recent history', symbol, index);
    setOpen(false);
  };

  return (
    <li>
      <Link
        href={`/trade/${instrument.productType}/${symbol}`}
        prefetch={false}
        onClick={handleClick}
        className={center({
          textStyle: 'Text/M/Regular',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'border.default.level-1',
          color: 'content.default.level-5',
          rounded: 1000,
          p: 6,
          pl: 12,
          gap: 4,
        })}
      >
        {instrument.displayShortName}
        <ProductTypeBadge productType={instrument.productType} />
      </Link>
    </li>
  );
};
